import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';

const ScrollTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 200) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Limpiar escuchador al desmontar
    };
  }, []); // Dependencia vacía para ejecutar efecto solo una vez

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div onClick={handleScrollToTop} className={`scroll-to-top ${showButton ? 'd-block' : 'd-none'}`}>
      <i class="bi bi-arrow-up"></i>
    </div>
  );
};

export default ScrollTop;
